import { render, staticRenderFns } from "./allModules.vue?vue&type=template&id=3d827781&scoped=true&"
import script from "./allModules.vue?vue&type=script&lang=js&"
export * from "./allModules.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=3d827781&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d827781",
  null
  
)

export default component.exports